import { ApiError } from "../store/types";

export const getErrorString = (errors: ApiError[]) : string => 
  errors.map(err => err.message).join('. ')